// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import FolderFillSvg from '@rsuite/icon-font/lib/file/FolderFill';
var FolderFill = createSvgIcon({
  as: FolderFillSvg,
  ariaLabel: 'folder fill',
  category: 'file',
  displayName: 'FolderFill'
});
export default FolderFill;